import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyPackagesComponent } from './components/dashboard/my-packages/my-packages.component';
import { MyPurchasesComponent } from './components/dashboard/my-purchases/my-purchases.component';
import { HandedOutPackagesComponent } from './components/dashboard/handed-out-packages/handed-out-packages.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { AuthorizationGuardService } from './services/common/guards/authorization-guard.service';
import { RoleGuardService } from './services/common/guards/role-guard.service';
import { TestComponent } from './components/dashboard/test/test.component';
import { AppLayout } from './components/new-dashboard/app.layout';
import { TutorialVideosComponent } from './components/dashboard/tutorial-videos/tutorial-videos.component';

const routes: Routes = [
  {
    path: "dashboard",
    component: AppLayout,
    canActivate: [ AuthorizationGuardService ],
    data: { name: "Dashboard" },
    children: [
      {
        path: "my-packages",
        component: MyPackagesComponent,
        canActivate: [ RoleGuardService ],
        data: { name: "Hozzáférések" }
      },
      {
        path: "redeemed-packages",
        component: HandedOutPackagesComponent,
        canActivate: [ RoleGuardService ],
        data: { name: "Kiosztott" }
      },
      {
        path: "my-purchases",
        component: MyPurchasesComponent,
        canActivate: [ RoleGuardService ],
        data: { name: "Számlák" }
      },
      {
        path: "test",
        component: TestComponent,
        data: { name: "Teszt" }
      },
      {
        path: "my-vendor-selling-page",
        canActivate: [ RoleGuardService ],
        data: { name: "Saját oldalam" },
        loadChildren: () => {
          return import('./modules/pages/my-vendor-selling-page/my-vendor-selling-page.module').then(
            m => m.MyVendorSellingPageModule
          )
        }
      },
      {
        path: "tutorial-videos",
        component: TutorialVideosComponent,
        data: { name: "Videók" }
      }
    ]
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [ AuthorizationGuardService ],
    data: { name: "Bejelentkezés" }
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    data: { name: "Elfelejtett jelszó" }
  },
  { path: "**", pathMatch: "full", redirectTo: "login" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
